import "./Dairy.module.css";
import Header from "@/reusable_sections/Header";
import Lacticiniosintro from "./sections/Lacticiniosintro";
import Engineering from "./sections/Engineering";
import Footer from "@/reusable_sections/Footer";
export default function DairyPage() {
  return <div>
      <Header />
      <Lacticiniosintro />
      <Engineering />
      <Footer />
    </div>;
}